import styled from 'styled-components';

export const MenuButton = styled.button`

	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	padding: 13px;
	position: absolute;
	top: 20px;
	right: 20px;
	z-index: 950;
	background-color: rgba(255,255,255,0.6);
	cursor: pointer;
	border: 0;
	outline: 0;
	font-family: 'Poppins', sans-serif;
	color: #333;
	font-size: 18px;
	transition: 200ms;
	box-shadow: 0 10px 15px -20px black;

	p {
		margin-right: 10px;
		font-weight: bold;
	}

	svg{
		transition: 200ms;
	}

	&:hover{
		background-color: rgba(255,255,255,1);

		svg{
			transform: scale(1.2);
		}
	}

`;

export const Menu = styled.div`

	max-height: calc(100% - 40px);
	overflow-y: hidden;
	width: 100%;
	max-width: 400px;
	display: flex;
	flex-flow: column nowrap;
	position: absolute;
	top: 20px;
	right: 20px;
	z-index: 960;
	background-color: white;
	font-family: 'Poppins', sans-serif;
	font-size: 18px;
	box-shadow: 0 10px 15px -20px black;

	transition: 300ms;
  transform: ${props => props.open ? 'translateX(0%)' : 'translateX(calc(100% + 20px))'};
	@media (max-width: 520px) {
		max-width: 320px;
		transform: ${props => props.open ? 'translateX(0% + 20px)' : 'translateX(calc(100% + 20px))'};
	}
	@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) { 
		transform: ${props => props.open ? 'translateX(0%)' : 'translateX(120%)'};
	}
  transition-timing-function: cubic-bezier(.8,0,.2,1);
  
`;

export const Header = styled.button`

	width: 100%;
	height: 53px;
	display: flex;
	flex: none;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	outline: none;
	border: none;
	background: #eee;
	color: #333;
	font-family: 'Poppins', sans-serif;
	font-size: 18px;
	font-weight: bold;
	padding: 0 20px;

	svg {
		cursor: pointer;
		transition: 200ms;
		font-size: 20px;
	}

	svg:hover{
		transform: scale(1.2);
	}
	
`;

export const Content = styled.div`
	width: 100%;
  overflow-y: auto;
	@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) { 
		overflow-y: scroll;
		max-height: 80vh;
	}
`;

export const Tile = styled.div`

	padding: 20px;
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	font-size: 17px;
	cursor: pointer;
	transition: background-color 200ms;
	color: #333;
	border-bottom: 1px solid #eee;
	
	&:hover {
		background-color: #f6f6f6;

		svg{
			transform: scale(1.2);
		}
	}

	svg {
		margin-right: 15px;
		transition: 200ms;
	}
`;